import React from "react";

export const ViewDeposit = ({ deposits }) => {
  return (
    <div className="view-deposit-result">
      <table>
        <thead>
          <tr>
            <th>Deposit ID</th>
            <th>Account Number</th>
            <th>Deposit Type</th>
            <th>Start Date</th>
            <th>Amount</th>
            <th>Maturity Date</th>
            <th>Interest Rate</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {deposits.length && deposits.map((deposit, i) => (
            <tr key={i}>
              <td>{deposit.deposit_id}</td>
              <td>{deposit.account_number}</td>
              <td>{deposit.deposit_type}</td>
              <td>{deposit.start_date ? deposit.start_date.slice(0, 10) : 'N/A'}</td>
              <td>₹{deposit.amount}</td>
              <td>{deposit.maturity_date ? deposit.maturity_date.slice(0, 10) : 'N/A'}</td>
              <td>{deposit.interest_rate}%</td>
              <td>{deposit.status}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
